import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminEventTemplates({
  onUseTemplate,
  onEditTemplate,
  onAddTemplate,
  refreshKey = 0,
}) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const api = process.env.REACT_APP_API_URL;

  function getToken() {
    return localStorage.getItem('adminToken') || '';
  }

  async function fetchTemplates() {
    try {
      setLoading(true);

      const res = await axios.get(
        `${api}/admin/event-templates`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      setTemplates(res.data?.templates || []);
    } catch (err) {
      console.error(
        '[AdminEventTemplates fetch]',
        err?.response?.data || err.message
      );

      alert(
        err?.response?.data?.message ||
          'Failed to load templates.'
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  async function handleDelete(template) {
    if (!template?._id) return;

    const ok = window.confirm(
      `Delete "${template.name}" template?`
    );

    if (!ok) return;

    try {
      await axios.delete(
        `${api}/admin/event-templates/${template._id}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      fetchTemplates();
    } catch (err) {
      alert(
        err?.response?.data?.message ||
          'Failed to delete template.'
      );
    }
  }

  if (loading) {
    return (
      <div style={{ marginBottom: 24 }}>
        Loading templates...
      </div>
    );
  }

  return (
    <div
      style={{
        marginBottom: 28,
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        padding: 16,
        background: '#fff',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 14,
        }}
      >
        <div>
          <h3 style={{ margin: 0 }}>
            Templates
          </h3>

          <div
            style={{
              marginTop: 4,
              fontSize: 12,
              color: '#6b7280',
            }}
          >
            Load a template into the full event form, edit it, then publish.
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          {onAddTemplate && (
            <button
              type="button"
              onClick={onAddTemplate}
            >
              Add Template
            </button>
          )}

          <button
            type="button"
            onClick={fetchTemplates}
          >
            Refresh
          </button>
        </div>
      </div>

      {templates.length === 0 ? (
        <div
          style={{
            padding: '18px 0',
            color: '#6b7280',
          }}
        >
          No templates yet.
        </div>
      ) : (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
          }}
        >
          <thead>
            <tr
              style={{
                background: '#f8f8f8',
              }}
            >
              <th
                style={{
                  padding: 10,
                  textAlign: 'left',
                }}
              >
                Template
              </th>

              <th
                style={{
                  padding: 10,
                  textAlign: 'left',
                }}
              >
                Time
              </th>

              <th
                style={{
                  padding: 10,
                  textAlign: 'left',
                }}
              >
                Venue
              </th>

              <th
                style={{
                  padding: 10,
                  textAlign: 'left',
                }}
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {templates.map((template) => {
              const data =
                template.eventData || {};

              const time =
                data.startTime12 || data.endTime12
                  ? `${data.startTime12 || ''}${
                      data.startTime12 &&
                      data.endTime12
                        ? ' – '
                        : ''
                    }${data.endTime12 || ''}`
                  : '—';

              const venue =
                data.hostedAt ||
                data.venue ||
                '—';

              return (
                <tr
                  key={template._id}
                  style={{
                    borderBottom:
                      '1px solid #eee',
                  }}
                >
                  <td
                    style={{
                      padding: 10,
                      fontWeight: 800,
                    }}
                  >
                    {template.name}
                  </td>

                  <td style={{ padding: 10 }}>
                    {time}
                  </td>

                  <td style={{ padding: 10 }}>
                    {venue}
                  </td>

                  <td
                    style={{
                      padding: 10,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <button
                      type="button"
                      onClick={() =>
                        onUseTemplate?.(template)
                      }
                      style={{
                        marginRight: 8,
                      }}
                    >
                      Use Template
                    </button>

                    {onEditTemplate && (
                      <button
                        type="button"
                        onClick={() =>
                          onEditTemplate(
                            template
                          )
                        }
                        style={{
                          marginRight: 8,
                        }}
                      >
                        Edit
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={() =>
                        handleDelete(
                          template
                        )
                      }
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

    </div>
  );
}
